import type { MsgKey } from "../../../i18n";
import type { SourceGroupType } from "../complianceScope/utils";

/** i18n label key for each of the 4 visual source groups shown in the Sage Workflow mindmap. */
export function groupLabelKey(groupType: SourceGroupType): MsgKey {
  switch (groupType) {
    case "POLICY":
      return "sageGroupPolicies";
    case "RULE_CUSTOM":
      return "sageGroupCustomRules";
    case "RULE_TAUGHT":
      return "sageGroupEducateSage";
    case "DICTIONARY":
      return "sageGroupDictionary";
  }
}

/** Tailwind classes for a small count badge per group, kept distinct so the 4 groups read apart at a glance. */
export function groupBadgeClass(groupType: SourceGroupType): string {
  switch (groupType) {
    case "POLICY":
      return "bg-indigo-100 text-indigo-700";
    case "RULE_CUSTOM":
      return "bg-emerald-100 text-emerald-700";
    case "RULE_TAUGHT":
      return "bg-brand-100 text-brand-700";
    case "DICTIONARY":
      return "bg-amber-100 text-amber-700";
  }
}

/** Border/accent color per group, used on the group nodes and edges themselves. */
export function groupAccentClass(groupType: SourceGroupType): string {
  switch (groupType) {
    case "POLICY":
      return "border-indigo-300 bg-indigo-50";
    case "RULE_CUSTOM":
      return "border-emerald-300 bg-emerald-50";
    case "RULE_TAUGHT":
      return "border-brand-300 bg-brand-50";
    case "DICTIONARY":
      return "border-amber-300 bg-amber-50";
  }
}

export function groupEdgeColor(groupType: SourceGroupType): string {
  switch (groupType) {
    case "POLICY":
      return "#6366f1";
    case "RULE_CUSTOM":
      return "#10b981";
    case "RULE_TAUGHT":
      return "#4f46e5";
    case "DICTIONARY":
      return "#f59e0b";
  }
}

/** Neutral color for channel -> category edges, which span every group and so don't get a group color. */
export const CHANNEL_EDGE_COLOR = "#94a3b8";
